import React, { Component } from "react";
import { Link } from "react-router-dom";
import firebase from "../../firebase";
import SimpleCrypto from "simple-crypto-js";
import Constant from "../../Constant";
import Swal from "sweetalert2";

const db = firebase.firestore();

export default class Header extends Component {
  state = {
    otp: false,
    emailForm: true,
    email: "",
    password: "",
  };
  componentDidMount() { }
  onLogin = (e) => {
    e.preventDefault();

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    var urlencoded = new URLSearchParams();
    urlencoded.append("email", this.state.email);
    urlencoded.append("password", this.state.password);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/role/getAll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        this.setState({ roleList: result.data });
        // localStorage.setItem("livelms_auth", result.auth);
        // localStorage.setItem("livelms_login", true);
        // localStorage.setItem("livelms_role", "learner");
        // localStorage.setItem("lms_site_id", result.site.id);
        // localStorage.setItem("lms_site_name", result.site.name);

        // window.location.href = "#/admin/dashboard";
        // window.location.href = "#/learner/course-list";
        // window.location.reload();
      })
      .catch((error) => console.log("error", error));
  };
  onLogin = (e) => {
    e.preventDefault();

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    var urlencoded = new URLSearchParams();
    urlencoded.append("email", this.state.email);
    urlencoded.append("password", this.state.password);
    urlencoded.append("siteName", this.state.institute);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/user/login", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);

        if (result.role[0].name == "Trainer" || result.role[0].name == "trainer" || result.role[0].name == "TRAINER") {
          window.location.href = "#/trainer/dashboard";
          localStorage.setItem("livelms_role", "trainer");
        } else if (result.role[0].name == "Learner" || result.role[0].name == "learner" || result.role[0].name == "LEARNER") {
          window.location.href = "#/learner/course-list";
          localStorage.setItem("livelms_role", "learner");
        } else if (result.role[0].name == "Admin" || result.role[0].name == "admin" || result.role[0].name == "ADMIN") {
          localStorage.setItem("livelms_role", "admin");
          localStorage.setItem("livelms_view", "true");
          window.location.href = "#/admin/dashboard";
        }

        localStorage.setItem("livelms_auth", result.auth);
        localStorage.setItem("livelms_login", true);

        localStorage.setItem("livelms_firstName", result.firstName);
        localStorage.setItem("lms_site_id", result.site.id);
        localStorage.setItem("lms_uid", result.id);
        localStorage.setItem("lms_zconfig", JSON.stringify(result.zoomConfig));
        localStorage.setItem("lms_site_name", result.site.name);
        if (result.site.Medium !== null) {
          localStorage.setItem("lms_site_logo", result.site.Medium.url);
        }

        window.location.reload();
      })
      .catch((error) =>
        Swal.fire("Error", "Incorrect email and password!", "error")
      );
  };
  componentWillMount() {
    if (window.location.hostname.split('.')[0] !== "livelms") {
      this.checkSiteDetails(window.location.hostname.split('.')[0]);
    }
  }
  checkSiteDetails = (siteName) => {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
    // myHeaders.append('Authorization', localStorage.getItem('livelms_auth'));

    var urlencoded = new URLSearchParams();
    urlencoded.append('siteName', siteName);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
      redirect: 'follow',
    };

    fetch(Constant.getSiteAPI() + '/site/getAllAnon', requestOptions)
      .then(response => response.json())
      .then(result => {
        var data = result.data;
        for (var i = 0; i < result.data.length; i++) {
          if (result.data[i].name.toLowerCase() === siteName.toLowerCase()) {
            this.setState({
              name: result.data[i].name,
              description: result.data[i].description,
              MediumId: result.data[i].MediumId,
            });
            if (result.data[i].Medium !== null) {
              this.setState({
                image: result.data[i].Medium.url,
              });
            }
            localStorage.setItem("lms_site_name", result.data[i].name);
            if (result.data[i].Medium !== null) {
              localStorage.setItem("lms_site_logo", result.data[i].Medium.url);
            }
          }
        }
      })
      .catch(error => console.log('error', error));
  }
  onLogout = () => {
    localStorage.clear();
    window.location.href = "#/";
    window.location.reload();
  };
  onInputChange = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value });
    console.log(this.state);
  };
  otpForm = (e) => {
    e.preventDefault();
    this.setState({ otp: !this.state.otp });
    this.setState({ emailForm: !this.state.emailForm });
  };
  emailForm = (e) => {
    e.preventDefault();
    this.setState({ otp: !this.state.otp });
    this.setState({ emailForm: !this.state.emailForm });
  };

  // encryptPassword = password => {
  //   var _secretKey = "1";
  //   var simpleCrypto = new SimpleCrypto(_secretKey);

  //   var plainText = password;
  //   var cipherText = simpleCrypto.encrypt(plainText);
  //   return cipherText;
  // };

  // decryptPassword = password => {
  //   var _secretKey = "1";
  //   var simpleCrypto = new SimpleCrypto(_secretKey);

  //   var plainText = password;
  //   var decipherText = simpleCrypto.decrypt(plainText);

  //   return decipherText;
  // };
  date = () => {
    var currentdate = new Date();
    var datetime =
      currentdate.getDay() +
      "/" +
      currentdate.getMonth() +
      "/" +
      currentdate.getFullYear() +
      " " +
      currentdate.getHours() +
      ":" +
      currentdate.getMinutes() +
      ":" +
      currentdate.getSeconds();
    this.setState({ date: datetime });
  };
  asAdmin = () => {
    localStorage.setItem("livelms_role", "admin");
    localStorage.setItem("livelms_view", "true");

    window.location.href = "#/admin/dashboard";
    window.location.reload();
  };
  asTrainer = () => {
    localStorage.setItem("livelms_role", "trainer");
    localStorage.setItem("livelms_view", "true");

    window.location.href = "#/trainer/dashboard";
    window.location.reload();
  };
  asLearner = () => {
    localStorage.setItem("livelms_role", "learner");
    localStorage.setItem("livelms_view", "true");

    window.location.href = "#/learner/course-list";
    window.location.reload();
  };
  goToDashboard = () => {
    if (localStorage.getItem("livelms_role") == "learner") {
      window.location.href = "#/learner/course-list";
    } else if (localStorage.getItem("livelms_role") == "trainer") {
      window.location.href = "#/trainer/dashboard";
    }
  };
  render() {
    return (
      <div>
        <nav className="navbar navbar-default navbar-expand-lg navbar-light fixed-top shadow-sm">
          <div className="navbar-header d-flex col">
            {
              this.state.image !== undefined && this.state.image !== null && this.state.image !== ""
                ?
                <a className="navbar-brand brand-name" href="#">
                  <img src={this.state.image} alt={localStorage.getItem('lms_site_name')} height='30px' />
                </a>
                :
                localStorage.getItem('lms_site_logo') !== undefined && localStorage.getItem('lms_site_logo') !== null && localStorage.getItem('lms_site_logo') !== ""
                  ?
                  <a className="navbar-brand brand-name" href="#">
                    <img src={localStorage.getItem('lms_site_logo')} alt={localStorage.getItem('lms_site_name')} height='30px' />
                  </a>
                  :
                  <a className="navbar-brand brand-name" href="#">
                    LIVE<b>LMS</b>
                    {/* <b>Learnizm</b> */}
                  </a>
            }
            <button
              type="button"
              data-target="#navbarCollapse"
              data-toggle="collapse"
              className="navbar-toggle navbar-toggler ml-auto"
            >
              <span className="navbar-toggler-icon" />
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>
          </div>
          <div
            id="navbarCollapse"
            className="collapse navbar-collapse justify-content-start"
          >
            {/* {localStorage.getItem("livelms_login") === "true" ? (
              <div>
                <Link to="/admin/dashboard" className="mx-1">
                  <div className="btn btn-dark mx-auto text-center">Admin</div>
                </Link>
                <Link to="/trainer" className="mx-1">
                  <div className="btn btn-dark mx-auto text-center">
                    Trainer
                  </div>
                </Link>
                <Link to="/courses" className="mx-1">
                  <div className="btn btn-dark mx-auto text-center">
                    Learner
                  </div>
                </Link>
                <Link to="/createsession" className="mx-1">
                  <div className="btn btn-dark mx-auto text-center">
                    Create Session
                  </div>
                </Link>
              </div>
            ) : (
              <div></div>
            )} */}
            {/* <form className="navbar-form form-inline">
              <div className="input-group search-box">
                <input
                  type="text"
                  id="search"
                  className="form-control"
                  placeholder="Search here..."
                />
                <span className="input-group-addon">
                  <i class="material-icons">&#xE8B6;</i>
                </span>
              </div>
            </form> */}
            {localStorage.getItem("livelms_login") === "true" ? (
              <ul className="nav navbar-nav navbar-right ml-auto profile-dropdown mr-4">
                <li className="nav-item dropdown">
                  <a
                    data-toggle="dropdown"
                    className="nav-link dropdown-toggle"
                    href="#"
                  >
                    <img
                      src="https://unlimitedpassion.co.uk/wp-content/uploads/2016/06/placeholder4.png"
                      alt=""
                      style={{ width: "" }}
                      className="image-profile"
                    />
                    {localStorage.getItem("livelms_firstName")}
                    <i class="fas fa-sort-down ml-2" />
                  </a>
                  <ul className="dropdown-menu">
                    {/* <li>
                      <Link to="/profile" className="dropdown-item">
                        Profile
                      </Link>
                    </li>
                    <li>
                      <Link href="#" className="dropdown-item">
                        Courses
                      </Link>
                    </li>*/}
                    {localStorage.getItem("livelms_role") == "admin" ||
                      localStorage.getItem("livelms_role") == "superadmin" ||
                      localStorage.getItem("livelms_view") == "true" ? (
                        <React.Fragment>
                          <li>
                            <div className="dropdown-item" onClick={this.asAdmin}>
                              View as Administrator
                          </div>
                          </li>
                          <li>
                            <div
                              className="dropdown-item"
                              onClick={this.asTrainer}
                            >
                              View as Trainer
                          </div>
                          </li>
                          <li>
                            <div
                              className="dropdown-item"
                              onClick={this.asLearner}
                            >
                              View as Learner
                          </div>
                          </li>
                        </React.Fragment>
                      ) : (
                        <li>
                          <div
                            className="dropdown-item"
                            onClick={this.goToDashboard}
                          >
                            Dashboard
                        </div>
                        </li>
                      )}
                    <li>
                      <div className="dropdown-item" onClick={this.onLogout}>
                        Logout
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            ) : (
                <ul className="nav navbar-nav navbar-right ml-auto">
                  <li className="nav-item">
                    <a
                      data-toggle="dropdown"
                      className="nav-link dropdown-toggle"
                      href="#"
                    >
                      Login
                  </a>
                    <ul className="dropdown-menu form-wrapper">
                      <li>
                        {/* <div className="form-group clearfix">
                      {this.state.otp ? (
                        <input
                          className="btn btn-sm btn-block btn-secondary"
                          onClick={this.otpForm}
                          type="submit"
                          value="Email login"
                        />
                         
                      ) : (
                        <input
                          className="btn btn-sm btn-block btn-secondary"
                          type="submit"
                          onClick={this.otpForm}
                          value="OTP login"
                        />
                      )}
                    </div>
                    <div className="or-seperator">
                      <b>or</b>
                    </div> */}
                        {this.state.otp ? (
                          <form>
                            <p className="hint-text">OTP Login</p>
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Mobile No."
                                required="required"
                              />
                            </div>
                            <div className="form-group">
                              <input
                                type="submit"
                                className="btn btn-primary btn-block"
                                value="Get OTP"
                              />
                            </div>
                          </form>
                        ) : (
                            ""
                          )}

                        {this.state.emailForm ? (
                          <form>
                            <p className="hint-text">Email Login</p>
                            <div className="alert p-0 py-2 alert-danger text-center login-error d-none">
                              Email or password is incorrect
                          </div>
                            <div className="form-group">
                              <div class="input-group p-0">
                                <div class=" d-flex">
                                  <input
                                    type="text"
                                    class="form-control p-1 px-2 h-100"
                                    placeholder="Enter Domain"
                                    name="institute"
                                    value={this.state.institute}
                                    onChange={this.onInputChange}
                                  />
                                  <div class="input-group-append">
                                    <span class="input-group-text">
                                      .livelms.in
                                  </span>
                                  </div>
                                </div>
                                <div class="invalid-feedback">
                                  Sorry, that username's taken. Try another?
                              </div>
                              </div>
                            </div>

                            <div className="form-group">
                              <input
                                type="email"
                                className="form-control"
                                name="email"
                                placeholder="Email address"
                                required="required"
                                onChange={this.onInputChange}
                                value={this.state.email}
                              />
                            </div>
                            <div className="form-group">
                              <input
                                type="password"
                                className="form-control"
                                name="password"
                                placeholder="Password"
                                required="required"
                                onChange={this.onInputChange}
                                value={this.state.password}
                              />
                            </div>
                            <input
                              type="submit"
                              onClick={this.onLogin}
                              className="btn btn-primary btn-block"
                              value="Login"
                            />
                            <div className="form-footer">
                              <a href="#">Forgot Your password?</a>
                            </div>
                          </form>
                        ) : (
                            ""
                          )}
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/registration"
                      className="btn btn-primary get-started-btn mt-1 mb-1"
                    >
                      Sign up
                  </Link>
                    {/* <ul className="dropdown-menu form-wrapper">
                    <li>
                      <form
                        action="/examples/actions/confirmation.php"
                        method="post"
                      >
                        <p className="hint-text">
                          Fill in this form to create your account!
                        </p>
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Username"
                            required="required"
                          />
                        </div>
                        <div className="form-group">
                          <input
                            type="password"
                            className="form-control"
                            placeholder="Password"
                            required="required"
                          />
                        </div>
                        <div className="form-group">
                          <input
                            type="password"
                            className="form-control"
                            placeholder="Confirm Password"
                            required="required"
                          />
                        </div>
                        <div className="form-group">
                          <label className="checkbox-inline">
                            <input type="checkbox" required="required" /> I
                            accept the <a href="#">Terms &amp; Conditions</a>
                          </label>
                        </div>
                        <input
                          type="submit"
                          className="btn btn-primary btn-block"
                          value="Sign up"
                        />
                      </form>
                    </li>
                  </ul> */}
                  </li>
                </ul>
              )}

            <ul className="nav navbar-nav">
              {/* <li className="nav-item">
                  <Link to="/" className="nav-link">
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/courses" className="nav-link">
                    Courses
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/liveClass" className="nav-link">
                    Live Classes
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/createsession" className="nav-link">
                    Create Session
                  </Link>
                </li> */}
              {/* <li className="nav-item dropdown">
                <a
                  data-toggle="dropdown"
                  className="nav-link dropdown-toggle"
                  href="#"
                >
                  Services <b className="caret" />
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <a href="#" className="dropdown-item">
                      Web Design
                    </a>
                  </li>
                  <li>
                    <a href="#" className="dropdown-item">
                      Web Development
                    </a>
                  </li>
                  <li>
                    <a href="#" className="dropdown-item">
                      Graphic Design
                    </a>
                  </li>
                  <li>
                    <a href="#" className="dropdown-item">
                      Digital Marketing
                    </a>
                  </li>
                </ul>
              </li> */}
              {/* <li className="nav-item active">
                <a href="#" className="nav-link">
                  Pricing
                </a>
              </li>
              <li className="nav-item">
                <a href="#" className="nav-link">
                  Blog
                </a>
              </li>
              <li className="nav-item">
                <a href="#" className="nav-link">
                  Contact
                </a>
              </li> */}
            </ul>
          </div>
        </nav>
      </div>
    );
  }
}
